/**
 * Created by hernanherreros on 2019-05-30
 */

import * as React from 'react'
import styled from 'styled-components'
import { fontSize, FontSizeProps, space, SpaceProps } from 'styled-system'


const Label = styled.span<SpaceProps & FontSizeProps>`
  display: block;
  margin-bottom: 24px;

  ${space}
  ${fontSize}
`

export default Label
